import { Station } from '@app/core/types/stations';
import {
  AuditMentionsAuditMentionsMatchesListQueryParams,
  auditMentionsAuditMentionsMatchesListQueryKey,
  useAuditMentionsAuditMentionsMatchesList,
} from '@mi-front/api-v2';
import { DateTimeStr, TimeRange } from '@mi-front/core';
import { isAuditEnabled } from '../../../helpers';
import { AuditLiveMention } from '../types';
import { datetimeRangeCrudFilters } from '../../../utils/audit-matches-crud';

/**
 * Builds CRUD list filters for live mention matches in a datetime range.
 */
function liveMentionsMatchesQueryParams(
  station: Station,
  range: TimeRange<DateTimeStr>,
): AuditMentionsAuditMentionsMatchesListQueryParams {
  return {
    station: station.id,
    filter: datetimeRangeCrudFilters(range.from, range.to),
    limit: 250,
  };
}

/**
 * Fetches live mention matches for a station time range via api-v2 CRUD list.
 * Returns page `data` items (api-v2 DTOs) so consumers share the React Query cache.
 */
export function useAuditMentionsMatches(station: Station, range: TimeRange<DateTimeStr>) {
  const params = liveMentionsMatchesQueryParams(station, range);

  return useAuditMentionsAuditMentionsMatchesList(params, {
    query: {
      enabled: isAuditEnabled(station),
      select: (res): AuditLiveMention[] => res.data,
    },
  });
}

useAuditMentionsMatches.queryKey = (station: Station, range: TimeRange<DateTimeStr>) =>
  auditMentionsAuditMentionsMatchesListQueryKey(liveMentionsMatchesQueryParams(station, range));
